"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapListToApiObject = void 0;
/**
 * Maps a list of item codes to an array of objects that can be sent to the API.
 */
const mapListToApiObject = list => list.map(itemCode => ({
  itemCode
}));
exports.mapListToApiObject = mapListToApiObject;
